// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FashionInspiration-components-fashionInspirationIcon-FashionInspirationIcon-module-iconBlue {
    fill: var(--IconBlue);
}

.FashionInspiration-components-fashionInspirationIcon-FashionInspirationIcon-module-iconGrey {
    fill: var(--IconColor);
}
`, "",{"version":3,"sources":["webpack://./src/FashionInspiration/components/fashionInspirationIcon/FashionInspirationIcon.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".iconBlue {\n    fill: var(--IconBlue);\n}\n\n.iconGrey {\n    fill: var(--IconColor);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconBlue": `FashionInspiration-components-fashionInspirationIcon-FashionInspirationIcon-module-iconBlue`,
	"iconGrey": `FashionInspiration-components-fashionInspirationIcon-FashionInspirationIcon-module-iconGrey`
};
module.exports = ___CSS_LOADER_EXPORT___;
